
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CampaignResponse, AdvertisementResponse, ViewershipResult } from 'jsonutils/reports';
import { SET_PROGRESS } from './progressSlice';
import { getAdvertisementReportsData, getViewershipReportsData } from 'services/reports.service';
import { SEND_MESSAGE } from './errorHandlingSlice';
export interface ClientReportState {
    list: Array<any>;
    campaignResponse: CampaignResponse;
    advertisementResponse: AdvertisementResponse;
    advertisementResponselist: Array<any>;
    viewershipResponse: ViewershipResult;
    campaignTotalValue: any;
    isSidebarCollapsed: boolean;
}
const emptyViewershipResult: ViewershipResult = {
    dateArray: [],
    actualViewershipArray: [],
    potentialViewershipArray: [],
};

const emptyCampaignResponse: CampaignResponse = {
    campaignId: 0,
    campaignName: '',
    startDate: new Date(),
    endDate: new Date(),
};

const emptyAdvertisementResponse: AdvertisementResponse = {
    adId: 0,
    startDate: new Date(),
    endDate: new Date(),
    name: '',
};

const initialState: ClientReportState = {
    list: [],
    campaignResponse: emptyCampaignResponse,
    advertisementResponse: emptyAdvertisementResponse,
    advertisementResponselist: [],
    viewershipResponse: emptyViewershipResult,
    campaignTotalValue: {},
    isSidebarCollapsed: true

};

const clientReportsSlice = createSlice({
    name: 'ClientReports',
    initialState,
    reducers: {
        GET_CAMPAIGN_REPORT_LIST: (state, action: PayloadAction<any>): ClientReportState => {
            return {
                ...state,
                list: action.payload.data,
                campaignTotalValue: action.payload.totalData
            };
        },
        UPDATE_CAMPAIGN_REPORTS: (state, action: PayloadAction<any>): ClientReportState => {
            return {
                ...state,
                campaignResponse: { ...state.campaignResponse, ...action.payload },
            };
        },
        GET_ADVERTISEMENT_REPORT_LIST: (state, action: PayloadAction<any>): ClientReportState => {
            return {
                ...state,
                advertisementResponselist: action.payload,
            };
        },
        UPDATE_ADVERTISEMENT_REPORTS: (state, action: PayloadAction<any>): ClientReportState => {
            return {
                ...state,
                advertisementResponse: {
                    ...state.advertisementResponse,
                    ...action.payload,
                },
            };
        },
        GET_VIEWERSHIP_REPORT_LIST: (state, action: PayloadAction<any>): ClientReportState => {
            return {
                ...state,
                viewershipResponse: action.payload,
            };
        },
        RESET_CLIENT_REPORTS: (state, action: PayloadAction<any>): ClientReportState => {
            return {
                ...state,
                list: [],
                campaignResponse: emptyCampaignResponse,
                advertisementResponse: emptyAdvertisementResponse,
                advertisementResponselist: [],
                viewershipResponse: emptyViewershipResult,
            }
        },
        SIDEBAR_COLLAPSED: (state, action: PayloadAction<boolean>): ClientReportState => {
          return {
            ...state,
            isSidebarCollapsed: action.payload
          }

        }
    }
})

export const { GET_CAMPAIGN_REPORT_LIST, UPDATE_CAMPAIGN_REPORTS, GET_ADVERTISEMENT_REPORT_LIST,UPDATE_ADVERTISEMENT_REPORTS,GET_VIEWERSHIP_REPORT_LIST,RESET_CLIENT_REPORTS,SIDEBAR_COLLAPSED } = clientReportsSlice.actions
export default clientReportsSlice.reducer

export const getAdvertisementReports = (respData: any): any => async (dispatch: any) => {
    try {
          dispatch(SET_PROGRESS(true));
      const adReport: Array<any> = await getAdvertisementReportsData(respData);
          if (adReport.length > 0) {
        dispatch(GET_ADVERTISEMENT_REPORT_LIST(adReport));
          } else {
        dispatch(SEND_MESSAGE({ message:'No Data available', type:'error'}));
          }
      dispatch(SET_PROGRESS(false));
    } catch (error: any) {
      dispatch(SEND_MESSAGE({ message:error, type:'error'}));
      dispatch(SET_PROGRESS(false));
    }
  };

  export const resetClientReports = () => async (dispatch: any) => {
      try {
      dispatch(RESET_CLIENT_REPORTS(null))
      } catch (error: any) {
      dispatch(SEND_MESSAGE({ message:error, type:'error'}));
      }
  };

  export const updateCampaignReportFields = (data:Partial<CampaignResponse>) => async (dispatch: any) => {
      try {
      dispatch(UPDATE_CAMPAIGN_REPORTS(data))
      } catch (error: any) {
      dispatch(SEND_MESSAGE({ message:error, type:'error'}));
      }
  };
  export const updateAdvertisementReportFields = (data:Partial<AdvertisementResponse>) => async (dispatch: any) => {
	try {
    dispatch(UPDATE_ADVERTISEMENT_REPORTS(data))
	} catch (error: any) {
    dispatch(SEND_MESSAGE({ message:error, type:'error'}));
	}
};
export const getViewershipReports = (campId: any) => async (dispatch: any) => {
	try {
		dispatch(SET_PROGRESS(true));
		const viewershipReport: any = await getViewershipReportsData(campId);
		if (viewershipReport) {
      dispatch(GET_VIEWERSHIP_REPORT_LIST(viewershipReport));
		} else {
      dispatch(SEND_MESSAGE({ message:'No Data available', type:'warning'}));
		}
    dispatch(SET_PROGRESS(false));
	} catch (error: any) {
    dispatch(SEND_MESSAGE({ message:error, type:'error'}));
    dispatch(SET_PROGRESS(false));
	}
};
